<template>
  <div class="legal-texts-product-revisions-index-view">
    <search-input ref="search" v-model="searchQuery" />

    <data-grid
      :columns="gridColumns"
      :is-loading="isLoading"
      :page-info="paginate"
      :rows="entries"
      :sort-info="sort"
      :sortable="['name', 'articleNumber', 'validFrom', 'validUntil', 'updatedAt']"
      @sort="sortBy"
      class="uk-margin-medium"
      v-if="gridLoaded"
    >
      <span slot="empty">{{$t('hints.empty')}}</span>
      <template scope="props" slot="row">
        <td>
          <router-link
            :to="{ name: 'edit-product-revision',
                              params: { id: props.row.id } }"
          >{{props.row.product.name}}</router-link>
        </td>
        <td>{{props.row.product.articleNumber}}</td>
        <td>
          <validity :value="props.row.validFrom" />
        </td>
        <td>
          <validity :value="props.row.validFrom" />
        </td>
        <td>
          <timeago
            :auto-update="60"
            :since="props.row.updatedAt"
            v-if="props.row.updatedAt"
          />
          <text-placeholder v-else />
        </td>
        <td>
          <data-grid-actions
            :edit-route="{ name: 'edit-product-revision',
                           params: { id: props.row.id } }"
            :removable="false"
          />
        </td>
      </template>
    </data-grid>

    <div
      class="loader-container uk-container uk-margin-medium-top uk-text-center"
      v-else
    >
      <loader />
    </div>
  </div>
</template>

<script>
import AssocIndexView from '@/mixins/AssocIndexView';
import IndexView from '@/mixins/IndexView';
import legalTextQuery
  from '@/api/queries/legal-text-with-product-revisions.graphql';
import Validity from '@/components/Validity';

export default {
  name: 'product-revision-legal-texts-index-view',
  mixins: [
    IndexView('legalText', {
      gridFields: [
        'name',
        'articleNumber',
        'validFrom',
        'validUntil',
        'updatedAt',
      ],
      listQuery: legalTextQuery,
      nameField: record => record.product.name,
    }),
    AssocIndexView({
      assocName: 'productRevisions',
      resourceName: 'legalText',
      routeName: 'legal-text-product-revision',
      mutationVariables(record) {
        return {
          legalTextId: this.legalText.id,
          revisionId: record.id,
        };
      },
    }),
  ],
  components: {
    Validity,
  },
  computed: {
    gridColumns() {
      return {
        name: this.$t('fields.name'),
        articleNumber: this.$t('fields.articleNumber'),
        validFrom: this.$t('fields.validFrom'),
        validUntil: this.$t('fields.validUntil'),
        updatedAt: this.$t('fields.updatedAt'),
      };
    },
  },
  i18n: {
    messages: {
      de: {
        title: 'Produkte',
        actions: {
          new: 'Rechtstext erstellen',
        },
        confirmations: {
          delete: 'Verknüpfung mit Produkt-Revision wirklisch löschen?',
        },
        hints: {
          empty: 'Keine Produkt-Revisionen gefunden.',
        },
        toasts: {
          deleted: 'Verknüpfung mit Produkt-Revision gelöscht.',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductRevisionsIndexView.vue?20d16540